var _style, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKiveUsoComercialRacionadores(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 402.7 76.2",
    style: {
      enableBackground: "new 0 0 402.7 76.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#217F19;}\n\t.st1{fill:#217F19;stroke:#FFFFFF;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.6,
    y: 7,
    className: "st0",
    width: 8.9,
    height: 36.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 7,
    className: "st0",
    width: 8.9,
    height: 36.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9,
    y: 7,
    className: "st0",
    width: 8.9,
    height: 36.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 7,
    className: "st0",
    width: 8.9,
    height: 36.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.4,7 36.5,7 23.6,24.5 13.9,24.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "79.8,7 91.8,7 65.1,43.2 65.1,27.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "24,25.8 13.9,25.8 26.7,43.2 36.5,43.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "125.9,4.8 120.4,11.4 130.7,24.5 140.4,24.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "130.4,25.8 140.4,25.8 125.9,44.6 120,38.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.7,
    y: 7,
    className: "st0",
    width: 13.9,
    height: 7.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.7,
    y: 21,
    className: "st0",
    width: 8.4,
    height: 7.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.7,
    y: 35.4,
    className: "st0",
    width: 13.9,
    height: 7.9
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.4,17.5c0.7,0.7,1.7,1.1,3,1.1c1.3,0,2.2-0.4,3-1.1c0.7-0.7,1.1-1.7,1.1-2.9V5.2h3.2v9.3 c0,1.4-0.3,2.6-0.9,3.6c-0.6,1-1.4,1.8-2.5,2.3c-1.1,0.5-2.4,0.8-3.8,0.8c-1.5,0-2.8-0.3-3.9-0.8s-1.9-1.3-2.5-2.3 c-0.6-1-0.9-2.2-0.9-3.6V5.2h3.2v9.3C156.2,15.8,156.6,16.8,157.4,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.2,8.2c-0.9-0.3-1.7-0.4-2.4-0.4c-0.8,0-1.4,0.1-1.8,0.4c-0.4,0.3-0.7,0.6-0.7,1.1c0,0.4,0.2,0.8,0.5,1.1 c0.3,0.3,0.7,0.5,1.2,0.7c0.5,0.2,1.1,0.4,1.9,0.6c1.1,0.3,2.1,0.6,2.8,1c0.7,0.3,1.3,0.8,1.8,1.4s0.8,1.4,0.8,2.4 c0,1-0.3,1.8-0.8,2.5s-1.3,1.3-2.3,1.6c-1,0.4-2.1,0.6-3.3,0.6c-1.3,0-2.6-0.2-3.8-0.7c-1.2-0.5-2.3-1.1-3.2-1.8l1.3-2.6 c0.8,0.7,1.8,1.3,2.8,1.7s2,0.6,2.9,0.6c0.9,0,1.6-0.2,2.1-0.5c0.5-0.3,0.8-0.8,0.8-1.3c0-0.5-0.2-0.8-0.5-1.1 c-0.3-0.3-0.7-0.5-1.2-0.7c-0.5-0.2-1.1-0.4-2-0.6c-1.1-0.3-2-0.6-2.8-0.9c-0.7-0.3-1.3-0.8-1.8-1.4c-0.5-0.6-0.8-1.4-0.8-2.4 c0-0.9,0.3-1.7,0.8-2.4c0.5-0.7,1.2-1.2,2.2-1.6c0.9-0.4,2-0.6,3.3-0.6c1.1,0,2.1,0.2,3.2,0.5c1.1,0.3,2,0.7,2.8,1.2l-1.3,2.7 C181,8.8,180.1,8.4,179.2,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.4,6.1c1.4,0.7,2.4,1.7,3.2,2.9c0.8,1.2,1.2,2.6,1.2,4.1s-0.4,2.9-1.2,4.1c-0.8,1.2-1.8,2.2-3.2,3 c-1.4,0.7-2.9,1.1-4.5,1.1c-1.7,0-3.2-0.4-4.5-1.1c-1.4-0.7-2.4-1.7-3.2-3c-0.8-1.2-1.2-2.6-1.2-4.1s0.4-2.9,1.2-4.1 c0.8-1.2,1.8-2.2,3.2-2.9s2.9-1.1,4.5-1.1C195.5,5,197,5.4,198.4,6.1z M191.1,8.5c-0.9,0.5-1.6,1.1-2.1,1.9 c-0.5,0.8-0.8,1.7-0.8,2.7s0.3,1.9,0.8,2.7s1.2,1.5,2.1,2c0.9,0.5,1.8,0.7,2.8,0.7c1,0,1.9-0.2,2.8-0.7c0.9-0.5,1.5-1.1,2-2 s0.8-1.7,0.8-2.7s-0.2-1.9-0.8-2.7s-1.2-1.5-2-1.9s-1.8-0.7-2.8-0.7C192.9,7.8,192,8,191.1,8.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.3,30.4c-0.8-0.4-1.6-0.5-2.4-0.5c-1,0-2,0.2-2.8,0.7c-0.9,0.5-1.5,1.1-2,1.9c-0.5,0.8-0.7,1.7-0.7,2.7 s0.2,1.9,0.7,2.7c0.5,0.8,1.2,1.5,2,1.9s1.8,0.7,2.8,0.7c0.8,0,1.6-0.2,2.4-0.5c0.8-0.3,1.5-0.8,2.1-1.4l1.9,2 c-0.9,0.8-1.9,1.5-3,2c-1.2,0.5-2.3,0.7-3.5,0.7c-1.6,0-3.1-0.4-4.4-1.1s-2.4-1.7-3.1-3c-0.8-1.2-1.1-2.6-1.1-4.1s0.4-2.9,1.2-4.1 c0.8-1.2,1.8-2.2,3.2-2.9c1.3-0.7,2.8-1.1,4.5-1.1c1.2,0,2.4,0.2,3.5,0.7c1.1,0.5,2.1,1.1,2.9,1.9l-1.9,2.2 C164.8,31.3,164.1,30.8,163.3,30.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.7,28.2c1.4,0.7,2.4,1.7,3.2,2.9c0.8,1.2,1.2,2.6,1.2,4.1s-0.4,2.9-1.2,4.1c-0.8,1.2-1.8,2.2-3.2,3 s-2.9,1.1-4.5,1.1c-1.7,0-3.2-0.4-4.5-1.1s-2.4-1.7-3.2-3c-0.8-1.2-1.2-2.6-1.2-4.1s0.4-2.9,1.2-4.1c0.8-1.2,1.8-2.2,3.2-2.9 s2.9-1.1,4.5-1.1C178.8,27.1,180.3,27.5,181.7,28.2z M174.4,30.6c-0.9,0.5-1.6,1.1-2.1,1.9c-0.5,0.8-0.8,1.7-0.8,2.7 s0.3,1.9,0.8,2.7s1.2,1.5,2.1,2c0.9,0.5,1.8,0.7,2.8,0.7c1,0,1.9-0.2,2.8-0.7c0.9-0.5,1.5-1.1,2-2s0.8-1.7,0.8-2.7 s-0.2-1.9-0.8-2.7s-1.2-1.5-2-1.9s-1.8-0.7-2.8-0.7C176.2,29.9,175.2,30.1,174.4,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.8,27.3h3.6l5.5,10.2l5.5-10.2h3.6v15.9h-2.9V31.8l-5.2,9.7h-2l-5.2-9.7v11.4h-2.9V27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.2,27.3h12.2V30h-9v3.9h8.1v2.7h-8.1v4h9.3v2.7h-12.5V27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.4,43.2l-2.9-4.7c-0.1,0-0.3,0-0.6,0h-3.8v4.7H227V27.3h7c2.2,0,3.8,0.5,5,1.4c1.2,1,1.8,2.3,1.8,4 c0,1.2-0.3,2.3-0.8,3.2c-0.6,0.9-1.4,1.5-2.5,2l3.7,5.3H237.4z M230.1,35.9h3.8c1.2,0,2.1-0.2,2.8-0.7c0.6-0.5,1-1.2,1-2.2 c0-1-0.3-1.7-1-2.2c-0.6-0.5-1.6-0.7-2.8-0.7h-3.8V35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.2,30.4c-0.8-0.4-1.6-0.5-2.4-0.5c-1,0-2,0.2-2.8,0.7c-0.9,0.5-1.5,1.1-2,1.9s-0.7,1.7-0.7,2.7 s0.2,1.9,0.7,2.7s1.2,1.5,2,1.9s1.8,0.7,2.8,0.7c0.8,0,1.6-0.2,2.4-0.5c0.8-0.3,1.5-0.8,2.1-1.4l1.9,2c-0.9,0.8-1.9,1.5-3,2 c-1.2,0.5-2.3,0.7-3.5,0.7c-1.6,0-3.1-0.4-4.4-1.1c-1.3-0.7-2.4-1.7-3.1-3c-0.8-1.2-1.1-2.6-1.1-4.1s0.4-2.9,1.2-4.1 c0.8-1.2,1.8-2.2,3.2-2.9c1.3-0.7,2.8-1.1,4.5-1.1c1.2,0,2.4,0.2,3.5,0.7c1.1,0.5,2.1,1.1,2.9,1.9l-1.9,2.2 C255.6,31.3,255,30.8,254.2,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.7,27.3h3.2v15.9h-3.2V27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.3,43.2l-1.5-3.4h-8.1l-1.5,3.4h-3.3l7.3-15.9h3.3l7.2,15.9H280.3z M271.9,37.2h5.9l-2.9-6.7L271.9,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.8,27.3h3.2v13.1h7.2v2.7h-10.4V27.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiveUsoComercialRacionadores);
export default __webpack_public_path__ + "static/media/kive-uso-comercial-racionadores.a7a85b82ef43199b971f8bb65c1e3cbf.svg";
export { ForwardRef as ReactComponent };